import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-sortable-header",
  templateUrl: "./sortable-header.component.html",
  styleUrls: ["./sortable-header.component.scss"],
})
export class SortableHeaderComponent {
  @Input() column: string ="";
  @Input() currentOrdering: string ="";
  @Output() sort = new EventEmitter<string>();
  isCurrentOrder: boolean = false;
  @Input() isAscending: boolean = false;
  
  onSort() {
    this.sort.emit(this.column)
  }
}
